import React from 'react'
import type {ReactNode} from 'react'
import {PageContainer} from '@ant-design/pro-layout'
import ProCard from '@ant-design/pro-card'
import {Table} from 'antd'
import type {PageHeaderProps} from '@ant-design/pro-components'
import {TablePaginationConfig} from 'antd/es/table/interface'
import {randomCoding} from '@/utils'
import './index.less'

export interface ITablePageProps {
  title: string
  extra?: React.JSX.Element
  loading?: boolean
  columns: any
  tableData: Array<any> | undefined
  pagination: TablePaginationConfig | false
  scrollX?: number
  expandable?: any
  header?: PageHeaderProps
  tableHeader?: ReactNode
}

/**
 * 通用配置页面
 * @param props
 * @returns
 */
const TablePageComponent = (props: ITablePageProps) => {
  const {header, tableHeader} = props
  return (
    <PageContainer
      title={props.title}
      header={header}
      fixedHeader={true}
      extra={props.extra}
      className={"w-full h-full admin-page"}
    >
      <ProCard>
        {tableHeader}
        <Table
          loading={props.loading}
          pagination={props.pagination}
          rowKey={() => randomCoding()}
          expandable={props.expandable}
          scroll={{
            x: props.scrollX ?? 'auto',
          }}
          size="small"
          dataSource={props.tableData}
          columns={props.columns}
        />
      </ProCard>
    </PageContainer>
  )
}

export default TablePageComponent
